/* eslint-disable @typescript-eslint/no-explicit-any */
import { isArray } from "./isArray";
import { isString } from "./isString";

export const isEmpty = (value: any): boolean => {
  if (value === null || value === undefined) {
    return true;
  }

  if (isString(value) && value.length === 0) {
    return true;
  }

  if (isArray(value) && value.length === 0) {
    return true;
  }

  if (typeof value === "object" && Object.keys(value).length === 0) {
    return true;
  }

  return false;
};
